const blogPostPage = {
  key: 'blogPostPage',
  name: 'Blog Post Page',

  relatedArticles: 'Related Articles',
  relatedProducts: 'Related Products',
};

exports.blogPostPage = blogPostPage;
